/* SellAbroad integration for mahoneypep-theme.
   Loaded synchronously in <head> BEFORE the Peptide-Pay snippet (which is
   rendered just before </body>). Order matters: this script registers
   capture-phase listeners during parse; Peptide-Pay registers its capture-
   phase listeners later. First registration wins for document-level capture,
   so for geo-allowed visitors SA's stopImmediatePropagation() fires before
   Peptide-Pay's interceptor ever sees the click.

   For non-geo visitors: this script does NOTHING. Peptide-Pay continues to
   handle all checkout flows exactly as it does today. ZERO behaviour change.

   Liquid-set window globals consumed here (set by an inline <script> just
   before this asset is loaded):
     window.__saShopifyCountry, __saShopifyCurrency, __saShopCurrency
*/

(function () {
  var MERCHANT_ID = '01KRNRN9A6GJPT6MJEBEVCFXPE';
  var API_KEY = '2264fb45af1419f74adb9eb7d128184454b90e9fca6e6d6b8b2d10b4667af91e';
  var OMS = 'https://oms.sellabroad.io';
  var CHECKOUT_PAGE = '/pages/sa-chk/checkout';

  window.__saMerchantId = MERCHANT_ID;

  /* 46-country GEO_ALLOWED — full market expansion list */
  var GEO_ALLOWED = ['AE','AT','BE','BG','BH','CA','CH','CY','CZ','DE','DK','EE','EG','ES','FI','FR','GB','GR','HR','HU','IE','IT','JP','KW','LI','LT','LU','LV','MT','MY','NL','NO','NZ','OM','PL','PT','QA','RO','SA','SE','SG','SI','SK','TH','US'];
  window.__SA_GEO_ALLOWED = GEO_ALLOWED;

  var COUNTRY_TO_CCY = {
    AE:'AED', AT:'EUR', AU:'AUD', BE:'EUR', BG:'BGN', BH:'BHD', CA:'CAD',
    CH:'CHF', CY:'EUR', CZ:'CZK', DE:'EUR', DK:'DKK', EE:'EUR', EG:'EGP',
    ES:'EUR', FI:'EUR', FR:'EUR', GB:'GBP', GR:'EUR', HR:'EUR', HU:'HUF',
    IE:'EUR', IT:'EUR', JP:'JPY', KW:'KWD', LI:'CHF', LT:'EUR', LU:'EUR',
    LV:'EUR', MT:'EUR', MY:'MYR', NL:'EUR', NO:'NOK', NZ:'NZD', OM:'OMR',
    PL:'PLN', PT:'EUR', QA:'QAR', RO:'RON', SA:'SAR', SE:'SEK', SG:'SGD',
    SI:'EUR', SK:'EUR', TH:'THB', US:'USD'
  };
  var CURRENCY_DECIMALS = {
    AED:2, SAR:2, QAR:2, EGP:2, KWD:3, OMR:3, BHD:3, USD:2, EUR:2, GBP:2,
    AUD:2, CAD:2, SGD:2, BGN:2, CZK:2, DKK:2, HUF:2, PLN:2, RON:2, SEK:2,
    CHF:2, NOK:2, JPY:0, MYR:2, NZD:2, THB:2
  };
  var CURRENCY_SYMBOL = {
    USD:'$', EUR:'€', GBP:'£',
    AED:'AED ', SAR:'SAR ', QAR:'QAR ', EGP:'EGP ', KWD:'KWD ', OMR:'OMR ', BHD:'BHD ',
    AUD:'A$ ', CAD:'CA$ ', SGD:'SGD ', NZD:'NZ$ ',
    BGN:'лв ', CZK:'Kč ', DKK:'kr ', HUF:'Ft ', PLN:'zł ', RON:'lei ',
    SEK:'SEK ', CHF:'CHF ', NOK:'NOK ',
    JPY:'¥', MYR:'RM ', THB:'฿'
  };

  /* Footer payment icons (per-country mapping; default fallback for the rest) */
  var PAYMENT_ICON_LIST = [
    { name:'Visa', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/visa.png' },
    { name:'Mastercard', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/mastercard.svg' },
    { name:'American Express', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/amex.svg' },
    { name:'Apple Pay', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/apple-black.svg' },
    { name:'Google Pay', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/google-pay.png' },
    { name:'Amazon Pay', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/amazon-pay.svg' },
    { name:'Cash App', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/cashapp.svg' },
    { name:'Zip', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/zip.svg' },
    { name:'Bancontact', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/bancontact.svg' },
    { name:'EPS', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/eps.svg' },
    { name:'Ideal', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/ideal.svg' },
    { name:'MB Way', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/mb-way.svg' },
    { name:'Multibanco', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/multibanco.svg' },
    { name:'P24', src:'https://sellabroad-uploads.s3.eu-west-1.amazonaws.com/logos/p24.svg' }
  ];
  var COUNTRY_FOOTER_ICONS = {
    US: ['Visa','Mastercard','American Express','Apple Pay','Google Pay','Amazon Pay','Cash App','Zip'],
    GB: ['Visa','Mastercard','American Express','Apple Pay','Google Pay'],
    AU: ['Visa','Mastercard','American Express','Apple Pay','Google Pay','Amazon Pay','Zip'],
    CA: ['Visa','Mastercard','American Express','Apple Pay','Google Pay','Amazon Pay'],
    AE: ['Visa','Mastercard','American Express','Apple Pay','Google Pay'],
    SA: ['Visa','Mastercard','American Express','Apple Pay','Google Pay'],
    EG: ['Visa','Mastercard','American Express','Apple Pay','Google Pay'],
    KW: ['Visa','Mastercard','American Express','Apple Pay','Google Pay'],
    OM: ['Visa','Mastercard','American Express','Apple Pay','Google Pay'],
    BH: ['Visa','Mastercard','American Express','Apple Pay','Google Pay'],
    QA: ['Visa','Mastercard','American Express','Apple Pay','Google Pay'],
    PT: ['Visa','Mastercard','American Express','Apple Pay','Google Pay','MB Way','Multibanco'],
    BE: ['Visa','Mastercard','American Express','Apple Pay','Google Pay','Bancontact'],
    AT: ['Visa','Mastercard','American Express','Apple Pay','Google Pay','EPS'],
    NL: ['Visa','Mastercard','American Express','Apple Pay','Google Pay','Ideal'],
    PL: ['Visa','Mastercard','American Express','Apple Pay','Google Pay','P24']
  };
  var DEFAULT_FOOTER_ICONS = ['Visa','Mastercard','American Express','Apple Pay','Google Pay'];
  window.__SA_COUNTRY_FOOTER_ICONS = COUNTRY_FOOTER_ICONS;

  var SA_SESSION_KEY = 'sa_allowed_' + MERCHANT_ID;
  var SA_COUNTRY_KEY = 'sa_country_' + MERCHANT_ID;
  var SHOP_CCY = (window.__saShopCurrency || 'USD').toUpperCase();
  var cartId = null, mirrorPromise = null;

  function log(){ if (window.__saDebug) try { console.debug.apply(console, ['[SA]'].concat([].slice.call(arguments))); } catch(e){} }

  function isGeoAllowed(c){ return !!c && GEO_ALLOWED.indexOf(String(c).toUpperCase()) !== -1; }

  /* sa_force_geo URL hook — opt-in QA from a single IP */
  function readForceGeo() {
    try {
      var u = new URL(window.location.href);
      var v = u.searchParams.get('sa_force_geo');
      if (v) { sessionStorage.setItem('sa_force_geo', v.toUpperCase()); return v.toUpperCase(); }
      var s = sessionStorage.getItem('sa_force_geo');
      return s ? s.toUpperCase() : null;
    } catch(e) { return null; }
  }

  function applyBodyState(country) {
    var b = document.body;
    if (!b) return;
    b.classList.remove('sa-geo-pending');
    if (isGeoAllowed(country)) b.classList.add('sa-geo-allowed');
    else b.classList.remove('sa-geo-allowed');
  }
  function markPending(){
    if (document.body) document.body.classList.add('sa-geo-pending');
    else document.addEventListener('DOMContentLoaded', markPending, { once:true });
  }
  markPending();

  function readCachedCountry() {
    try {
      var c = sessionStorage.getItem(SA_COUNTRY_KEY);
      return c ? c.toUpperCase() : null;
    } catch(e){ return null; }
  }
  function cacheCountry(c) {
    try {
      sessionStorage.setItem(SA_COUNTRY_KEY, c);
      sessionStorage.setItem(SA_SESSION_KEY, isGeoAllowed(c) ? '1' : '0');
    } catch(e){}
  }

  var forced = readForceGeo();
  if (forced) { window.__saGeoCountry = forced; cacheCountry(forced); }
  else {
    var cached = readCachedCountry();
    if (cached) window.__saGeoCountry = cached;
  }

  function fetchGeo() {
    if (forced) { onGeoResolved(forced); return; }
    fetch(OMS + '/geolocation', {
      method:'GET',
      headers:{ 'x-api-key': API_KEY, 'x-merchant-id': MERCHANT_ID, 'Content-Type':'text/plain' }
    })
    .then(function(r){ return r.json(); })
    .then(function(j){
      var c = j && j.data && j.data.country_code;
      if (!c) throw new Error('no country');
      onGeoResolved(String(c).toUpperCase());
    })
    .catch(function(err){
      log('geo failed', err);
      onGeoResolved(window.__saShopifyCountry || '');
    });
  }

  function onGeoResolved(country) {
    window.__saGeoCountry = country;
    cacheCountry(country);
    applyBodyState(country);
    var allowed = isGeoAllowed(country);
    if (allowed) {
      var ccy = COUNTRY_TO_CCY[country];
      convertAllPrices(ccy);
      updateFooterPayments(country);
      ensureUpCartGeoStyles();
      startExpressCheckout();
    }
    try { document.dispatchEvent(new CustomEvent('sa:geoResolved', { detail:{ country: country, allowed: allowed }})); } catch(e){}
  }

  /* ---------- Currency conversion ---------- */
  var __fxCache = {};
  function getRate(from, to) {
    if (from === to) return Promise.resolve(1);
    var k = from + '_' + to;
    if (__fxCache[k]) return Promise.resolve(__fxCache[k]);
    return fetch(OMS + '/currency/rates?from=' + encodeURIComponent(from) + '&to=' + encodeURIComponent(to), {
      method:'GET', headers:{ 'x-api-key': API_KEY, 'Accept':'application/json' }, mode:'cors'
    })
    .then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function(j){
      if (j && typeof j.rate === 'number') { __fxCache[k] = j.rate; return j.rate; }
      throw new Error('no rate');
    })
    .catch(function(){
      return fetch('https://api.frankfurter.app/latest?from=' + encodeURIComponent(from) + '&to=' + encodeURIComponent(to))
        .then(function(r){ return r.json(); })
        .then(function(j){
          var r = j && j.rates && j.rates[to];
          if (r) { __fxCache[k] = r; return r; }
          return null;
        }).catch(function(){ return null; });
    });
  }

  function formatPrice(amount, currency) {
    var dec = CURRENCY_DECIMALS[currency];
    if (dec == null) dec = 2;
    var nf = new Intl.NumberFormat(undefined, { minimumFractionDigits: dec, maximumFractionDigits: dec });
    if (CURRENCY_SYMBOL[currency]) return CURRENCY_SYMBOL[currency] + nf.format(amount);
    return nf.format(amount) + ' ' + currency;
  }

  /* GemPages prices (PDP + collection):
       regular = gp-product-price[gp-data*="regular"] .gp-price.gp-money
       compare = gp-product-price[gp-data*="compare"] .gp-product-compare-price
     Dawn cart prices:
       line items = .cart-item__price-wrapper .price, .product-option
       cart total = .totals__total-value
     Inline copy with $ tokens (free-shipping banners, referral rewards):
       GemPages .gp-text-instant p, .gp-icon-list-text p */
  function queryGemPrices(root) {
    root = root || document;
    var out = [];
    try {
      root.querySelectorAll('gp-product-price .gp-price.gp-money:not(.gp-product-compare-price), gp-product-price .gp-product-compare-price').forEach(function(n){ out.push(n); });
    } catch(e){}
    return out;
  }
  /* Standalone landing-page prices (layout-none templates): plain leaf spans
     holding a single $-amount, e.g. .pd-price "$104.95" / .pd-was "$250.00".
     Classes are unique to those pages, so this is a no-op elsewhere. */
  function queryLandingPrices(root) {
    root = root || document;
    var out = [];
    try {
      root.querySelectorAll('.pd-price, .pd-was').forEach(function(n){ out.push(n); });
    } catch(e){}
    return out;
  }
  function queryDawnPrices(root) {
    root = root || document;
    var out = [];
    try {
      /* Leaf-level price spans only — NEVER the .price__regular / .price__sale
         wrappers, because those also contain .visually-hidden SR labels that
         we must not clobber. */
      root.querySelectorAll('.cart-item__price-wrapper .price, .cart-item__price-wrapper .price--end, .product-option, .totals__total-value, .price-item--regular, .price-item--sale, .price-item--last').forEach(function(n){ out.push(n); });
    } catch(e){}
    return out;
  }

  /* Elements containing inline $ amounts inside prose (e.g. "Free shipping
     over 250$", "You Get $30", "300$ = 10%"). All GemPages text blocks expose
     a data-gp-text="" attribute regardless of which class combo they use
     (.gp-text, .gp-text-instant, .gp-icon-list-text, etc.) — that's the
     stable selector. MONEY_TOKEN_RE filter narrows to elements containing
     actual $-tokens so we don't scan every paragraph. */
  var MONEY_TOKEN_RE = /\$\s*(\d+(?:[.,]\d+)?)|(\d+(?:[.,]\d+)?)\s*\$/g;
  function queryInlineCopyWithMoney(root) {
    root = root || document;
    var out = [];
    try {
      root.querySelectorAll('[data-gp-text]').forEach(function(n){
        if (n.closest && n.closest('gp-product-price')) return;
        if (MONEY_TOKEN_RE.test(n.textContent || '')) out.push(n);
        MONEY_TOKEN_RE.lastIndex = 0; /* reset stateful regex */
      });
    } catch(e){}
    return out;
  }

  /* Convert every $-token inside the text-node descendants of `el`, preserving
     HTML structure. Stores the original on each text node so re-conversion
     uses the original USD value (not a converted-then-re-converted value). */
  function convertInlineMoney(el, rate, targetCcy) {
    if (!el) return;
    try {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = walker.nextNode())) {
        var orig = (n.__saInlineOrig != null) ? n.__saInlineOrig : n.nodeValue;
        if (n.__saInlineOrig == null) n.__saInlineOrig = orig;
        if (!orig || !/\$/.test(orig)) continue;
        var converted = orig.replace(MONEY_TOKEN_RE, function(m, before, after){
          var raw = (before != null ? before : after);
          if (raw == null) return m;
          var num = parseFloat(String(raw).replace(/,/g,''));
          if (isNaN(num)) return m;
          return formatPrice(num * rate, targetCcy);
        });
        if (n.nodeValue !== converted) n.nodeValue = converted;
      }
    } catch(e){}
  }

  function stampBase(node) {
    if (!node || node.dataset.saBase) return;
    var txt = (node.textContent || '').replace(/[\s ]+/g, ' ').trim();
    txt = txt.replace(/\s*(USD|EUR|GBP|AED|SAR|QAR|EGP|KWD|OMR|BHD|AUD|CAD|SGD|BGN|CZK|DKK|HUF|PLN|RON|SEK|CHF|NOK|JPY|MYR|NZD|THB)\s*$/i, '');
    var range = txt.match(/([\d.,]+)\s*[–-]\s*([\d.,]+)/);
    if (range) {
      node.dataset.saBaseRange = JSON.stringify([parseFloat(range[1].replace(/,/g,'')), parseFloat(range[2].replace(/,/g,''))]);
      node.dataset.saBase = 'range';
      return;
    }
    var m = txt.match(/(\d+(?:[.,]\d+)?)/);
    if (m) node.dataset.saBase = m[1].replace(/,/g,'');
  }

  function setVisiblePrice(el, formatted) {
    var existing = el.querySelector(':scope > .sa-price-visible');
    if (existing) {
      if (existing.textContent === formatted) return;
      existing.textContent = formatted;
      return;
    }
    var span = document.createElement('span');
    span.className = 'sa-price-visible';
    span.textContent = formatted;
    el.textContent = '';
    el.appendChild(span);
  }

  function convertNode(node, rate, targetCcy) {
    if (!node) return;
    if (node.dataset.saBase === 'range' && node.dataset.saBaseRange) {
      try {
        var arr = JSON.parse(node.dataset.saBaseRange);
        setVisiblePrice(node, formatPrice(arr[0] * rate, targetCcy) + ' – ' + formatPrice(arr[1] * rate, targetCcy));
      } catch(e){}
      return;
    }
    var base = parseFloat(node.dataset.saBase);
    if (isNaN(base)) return;
    setVisiblePrice(node, formatPrice(base * rate, targetCcy));
  }

  var __reconvertTimer = null, __currentRate = null, __currentCcy = null;
  function scheduleReconvert(root) {
    if (!__currentRate || !__currentCcy) return;
    if (__reconvertTimer) clearTimeout(__reconvertTimer);
    __reconvertTimer = setTimeout(function(){
      __reconvertTimer = null;
      requestAnimationFrame(function(){
        var nodes = queryGemPrices(root).concat(queryDawnPrices(root)).concat(queryLandingPrices(root));
        nodes.forEach(function(n){ stampBase(n); convertNode(n, __currentRate, __currentCcy); });
        queryInlineCopyWithMoney(root).forEach(function(el){ convertInlineMoney(el, __currentRate, __currentCcy); });
        convertUpCartShadow();
      });
    }, 180);
  }
  window.__saScheduleReconvert = scheduleReconvert;

  function convertAllPrices(targetCcy) {
    if (!targetCcy || targetCcy === SHOP_CCY) return;
    getRate(SHOP_CCY, targetCcy).then(function(rate){
      if (!rate) return;
      __currentRate = rate;
      __currentCcy = targetCcy;
      scheduleReconvert(document);
      var mo = new MutationObserver(function(){ scheduleReconvert(document); });
      mo.observe(document.documentElement, { childList:true, subtree:true, characterData:true });
      document.addEventListener('change', function(e){
        if (e.target && e.target.matches && e.target.matches('input[name="id"], select[name="id"], .variant__input')) {
          scheduleReconvert(document);
        }
      });
    });
  }

  /* ---------- UpCart shadow DOM ---------- */
  var __upcartShadow = null;
  function installUpCartShadow() {
    var attempts = 0;
    var iv = setInterval(function(){
      attempts++;
      var host = document.getElementById('upCart');
      if (host && host.shadowRoot) {
        if (!host.shadowRoot.__saWired) {
          host.shadowRoot.__saWired = 1;
          __upcartShadow = host.shadowRoot;
          /* Capture-phase listener registered first — beats Peptide-Pay's later bubble-phase listener inside same shadow root. Bails inside if !geo-allowed. */
          host.shadowRoot.addEventListener('click', shadowClickHandler, true);
          var mo = new MutationObserver(function(){ convertUpCartShadow(); ensureUpCartGeoStyles(); });
          mo.observe(host.shadowRoot, { childList:true, subtree:true, characterData:true });
          convertUpCartShadow();
          ensureUpCartGeoStyles();
        }
        clearInterval(iv);
      }
      if (attempts > 50) clearInterval(iv);
    }, 400);
  }

  /* Inject hide-rules into UpCart shadow root for geo-allowed visitors.
     Document-level CSS can't reach inside the shadow, so we ship a small
     <style> element into the shadow root itself. Idempotent. */
  function ensureUpCartGeoStyles() {
    if (!__upcartShadow) return;
    if (!document.body || !document.body.classList.contains('sa-geo-allowed')) return;
    if (__upcartShadow.getElementById('sa-upcart-geo-style')) return;
    var s = document.createElement('style');
    s.id = 'sa-upcart-geo-style';
    s.textContent = '.upcart-trust-badge { display: none !important; }';
    __upcartShadow.appendChild(s);
  }

  function convertUpCartShadow() {
    if (!__upcartShadow || !__currentRate || !__currentCcy) return;
    try {
      var walker = document.createTreeWalker(__upcartShadow, NodeFilter.SHOW_TEXT, {
        acceptNode: function(n){
          var t = n.nodeValue;
          if (!t || !/\d/.test(t)) return NodeFilter.FILTER_SKIP;
          var trimmed = t.replace(/[\s ]+/g, ' ').trim();
          if (/^(?:Checkout\s*[•·]\s*)?[$€£¥₹]?\s*\d[\d.,]*\s*(USD|EUR|GBP)?$/.test(trimmed)) return NodeFilter.FILTER_ACCEPT;
          return NodeFilter.FILTER_SKIP;
        }
      });
      var rate = __currentRate, ccy = __currentCcy;
      var node;
      while ((node = walker.nextNode())) {
        var parent = node.parentElement;
        if (!parent) continue;
        var orig = parent.dataset.saUpcartBase;
        var raw = node.nodeValue.replace(/[\s ]+/g, ' ').trim();
        if (!orig) {
          var m = raw.match(/(\d+(?:[.,]\d+)?)/);
          if (!m) continue;
          orig = m[1].replace(/,/g,'');
          parent.dataset.saUpcartBase = orig;
        }
        var base = parseFloat(orig);
        if (isNaN(base)) continue;
        var formatted = formatPrice(base * rate, ccy);
        var prefixMatch = raw.match(/^(Checkout\s*[•·]\s*)/);
        var newText = (prefixMatch ? prefixMatch[1] : '') + formatted;
        if (node.nodeValue !== newText) node.nodeValue = newText;
      }
      /* Inline copy inside UpCart shadow with $ tokens wrapped in prose:
           - "You're $190.00 away from FREE SHIPPING" (rewards message)
           - "(Save $18.00)" (line-item savings badge)
           - "Stack 300$ | Save 10%" (discount-code text)
         Uses convertInlineMoney so words/markup are preserved. */
      __upcartShadow.querySelectorAll('.upcart-internal-rewards__message, .upcart-public-rewards__message, [data-upcart-chunk="rewards-message"], .upcart-product-savings, .upcart-discount-code-text').forEach(function(el){
        convertInlineMoney(el, rate, ccy);
      });
    } catch(e) { log('upcart convert err', e); }
  }

  /* ---------- Cart helpers ---------- */
  function getMetaParams() {
    function getCookie(name){
      try {
        var v = document.cookie.split('; ').find(function(r){ return r.indexOf(name + '=') === 0; });
        return v ? v.split('=')[1] : null;
      } catch(e){ return null; }
    }
    var fbp = getCookie('_fbp');
    var fbc = getCookie('_fbc');
    if (!fbc) {
      try {
        var fbclid = new URLSearchParams(location.search).get('fbclid');
        if (fbclid) fbc = 'fb.1.' + Math.floor(Date.now()/1000) + '.' + fbclid;
      } catch(e){}
    }
    var o = {};
    if (fbp) o.fbp = fbp;
    if (fbc) o.fbc = fbc;
    return o;
  }

  function buildCheckoutUrl(cid, country) {
    var ccy = COUNTRY_TO_CCY[country] || SHOP_CCY;
    var meta = getMetaParams();
    var shopUrl = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : window.location.host;
    var url = window.location.origin + CHECKOUT_PAGE
      + '?cartId=' + encodeURIComponent(cid)
      + '&merchantId=' + encodeURIComponent(MERCHANT_ID)
      + '&intendedCurrencyCode=' + encodeURIComponent(ccy)
      + '&shopUrl=' + encodeURIComponent(shopUrl);
    if (meta.fbp) url += '&fbp=' + encodeURIComponent(meta.fbp);
    if (meta.fbc) url += '&fbc=' + encodeURIComponent(meta.fbc);
    return url;
  }

  function mirrorCart() {
    if (mirrorPromise) return mirrorPromise;
    mirrorPromise = fetch('/cart.js', { credentials:'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        return fetch(OMS + '/carts/from-shopify', {
          method:'POST', mode:'cors',
          headers:{ 'Content-Type':'application/json', 'x-merchant-id': MERCHANT_ID, 'x-api-key': API_KEY },
          body: JSON.stringify({ token: cart.token, currentCountryCode: window.__saGeoCountry })
        });
      })
      .then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function(j){
        cartId = (j.medusa_cart && j.medusa_cart.id) ? j.medusa_cart.id : j.id;
        return cartId;
      });
    return mirrorPromise;
  }

  function getSelectedVariantId() {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (meta && meta.selectedVariantId) return String(meta.selectedVariantId);
      var u = new URLSearchParams(location.search).get('variant');
      if (u) return String(u);
      var inp = document.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('[name="id"]');
      if (inp && inp.value) return String(inp.value);
    } catch(e){}
    return null;
  }

  /* Pull variant id + qty out of a Shopify cart permalink, e.g.
     "https://shop.com/cart/44879098904732:3" → { variantId:'44879098904732', qty:3 }. */
  function parseCartPermalink(href) {
    try {
      var m = String(href || '').match(/\/cart\/(\d+):(\d+)/);
      if (m) return { variantId: m[1], qty: parseInt(m[2], 10) || 1 };
    } catch(e){}
    return null;
  }

  /* ---------- Checkout + Buy Now flows ---------- */
  function setLoading(btn) {
    if (!btn) return;
    if (!btn.dataset.saOrig) btn.dataset.saOrig = btn.innerHTML || btn.textContent;
    btn.classList.add('sa-loading');
  }
  function clearLoading(btn) {
    if (!btn) return;
    btn.classList.remove('sa-loading');
  }

  function runCheckoutMirror(btn) {
    /* Always start a fresh mirror — cart may have changed (qty bumped, item
       removed) since any prior click in this page session. */
    mirrorPromise = null;
    cartId = null;
    setLoading(btn);
    mirrorCart()
      .then(function(cid){
        if (!cid) throw new Error('no cart id');
        window.__saNavigating = true;
        window.location.href = buildCheckoutUrl(cid, window.__saGeoCountry || 'US');
      })
      .catch(function(err){
        log('mirror failed', err);
        clearLoading(btn);
        mirrorPromise = null;
        alert('Could not start checkout. Please try again.');
      });
  }

  /* override = { variantId, qty } when the caller already knows them (e.g. a
     standalone landing page with no /cart/add form to read). */
  function runBuyNow(btn, override) {
    var variantId = (override && override.variantId) || getSelectedVariantId();
    if (!variantId) { runCheckoutMirror(btn); return; }
    setLoading(btn);
    var qty;
    if (override && override.qty) {
      qty = override.qty;
    } else {
      var qtyInput = document.querySelector('form[action*="/cart/add"] [name="quantity"]') || document.querySelector('[name="quantity"]');
      qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    }
    var country = window.__saGeoCountry || 'US';
    fetch(OMS + '/carts/buy-now', {
      method:'POST', mode:'cors',
      headers:{ 'Content-Type':'application/json', 'x-merchant-id': MERCHANT_ID, 'x-api-key': API_KEY },
      body: JSON.stringify({ data:[{ shopifyVariantId: variantId, quantity: qty }], currentCountryCode: country })
    })
    .then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function(j){
      var cid = (j.medusa_cart && j.medusa_cart.id) ? j.medusa_cart.id : j.id;
      if (!cid) throw new Error('no cart id');
      window.__saNavigating = true;
      window.location.href = buildCheckoutUrl(cid, country);
    })
    .catch(function(err){
      log('buy now failed', err);
      clearLoading(btn);
      alert('Could not start checkout. Please try again.');
    });
  }

  /* ---------- Document capture-phase hijack (registers FIRST → beats Peptide-Pay) ---------- */
  /* For geo-allowed: hijack to SA flow.
     For geo-PENDING (first visit, geo not yet resolved): block click, await
     geo, then either run SA flow (allowed) or replay the click (non-geo) so
     Peptide-Pay's listener handles it.
     For confirmed non-geo: do nothing — Peptide-Pay handles. */

  function awaitGeo(timeoutMs) {
    return new Promise(function(resolve){
      if (window.__saGeoCountry) { resolve(window.__saGeoCountry); return; }
      var done = false;
      var h = function(ev){ if (done) return; done = true; document.removeEventListener('sa:geoResolved', h); clearTimeout(t); resolve(ev && ev.detail && ev.detail.country); };
      document.addEventListener('sa:geoResolved', h);
      var t = setTimeout(function(){ if (done) return; done = true; document.removeEventListener('sa:geoResolved', h); resolve(window.__saGeoCountry || null); }, timeoutMs || 4000);
    });
  }

  /* Replay a click as a tagged synthetic event. SA handlers skip __saReplay
     events; Peptide-Pay's handlers don't check, so they fire normally. For
     <a> elements with href, also fall back to navigating to href if nothing
     prevents-default (covers the edge case where Peptide-Pay isn't loaded). */
  function replayClick(btn) {
    try {
      var ev = new MouseEvent('click', { bubbles: true, cancelable: true, composed: true });
      ev.__saReplay = true;
      var prevented = !btn.dispatchEvent(ev);
      if (!prevented && btn.tagName === 'A' && btn.href) window.location.href = btn.href;
    } catch(e){
      if (btn.tagName === 'A' && btn.href) window.location.href = btn.href;
    }
  }

  function handleCheckoutClick(e, btn, runner) {
    var allowed = document.body && document.body.classList.contains('sa-geo-allowed');
    if (allowed) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      runner(btn);
      return;
    }
    if (!window.__saGeoCountry) {
      /* Geo unresolved — block + wait + decide. Strict for geo-allowed. */
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      setLoading(btn);
      awaitGeo(4000).then(function(c){
        if (isGeoAllowed(c)) runner(btn);
        else { clearLoading(btn); replayClick(btn); }
      });
    }
    /* Else: confirmed non-geo → fall through, Peptide-Pay handles. */
  }

  function documentClickHandler(e) {
    if (e.__saReplay) return;
    if (!document.body) return;
    var t = e.target;
    if (!t || !t.closest) return;
    /* composedPath() reveals the real target inside open shadow roots
       (e.target is retargeted to the shadow host at document level).
       Document-capture fires BEFORE shadow-capture, so detecting upcart-checkout-button here is the primary path — the shadow listener stays as a backup in case this listener gets detached. */
    var path = e.composedPath ? e.composedPath() : null;
    if (path) {
      for (var i = 0; i < path.length; i++) {
        var n = path[i];
        if (n && n.classList && n.classList.contains && n.classList.contains('upcart-checkout-button')) {
          handleCheckoutClick(e, n, runCheckoutMirror);
          return;
        }
      }
    }
    var ppBtn = t.closest('#pp-checkout-btn');
    if (ppBtn) { handleCheckoutClick(e, ppBtn, runBuyNow); return; }
    /* Standalone landing page: single-product CTA is a native /cart/{variant}:{qty}
       permalink. Parse variant + qty from the href and route through Buy Now.
       Matches any such permalink anchor so client-rendered pages work without a
       fixed id; the info guard lets non-permalink /cart links fall through. */
    var lpBtn = t.closest('#checkout-btn, a[href*="/cart/"]');
    if (lpBtn) {
      var info = parseCartPermalink(lpBtn.getAttribute('href'));
      if (info) { handleCheckoutClick(e, lpBtn, function(b){ runBuyNow(b, info); }); return; }
    }
    var coBtn = t.closest('button[name="checkout"], #checkout, .cart__checkout-button, a[href="/checkout"], a[href^="/checkout?"], a[href^="/checkouts/"]');
    if (coBtn) { handleCheckoutClick(e, coBtn, runCheckoutMirror); return; }
  }
  function documentSubmitHandler(e) {
    if (!document.body || !document.body.classList.contains('sa-geo-allowed')) return;
    var form = e.target;
    if (!form || !form.matches) return;
    if (form.matches('form[action="/cart"], form[action^="/cart?"]')) {
      var s = e.submitter || form.querySelector('[name="checkout"]');
      if (s && (s.name === 'checkout' || (s.matches && s.matches('button[name="checkout"], #checkout, .cart__checkout-button')))) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        runCheckoutMirror(s);
      }
    }
  }
  document.addEventListener('click', documentClickHandler, true);
  document.addEventListener('submit', documentSubmitHandler, true);

  function shadowClickHandler(e) {
    if (e.__saReplay) return;
    if (!document.body) return;
    var path = e.composedPath ? e.composedPath() : [];
    var btn = null;
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (n && n.classList && n.classList.contains && n.classList.contains('upcart-checkout-button')) { btn = n; break; }
    }
    if (!btn) return;
    handleCheckoutClick(e, btn, runCheckoutMirror);
  }

  /* ---------- Express Checkout (Google Pay via SA gateway) ---------- */
  function isPdp() {
    try {
      var pt = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.pageType;
      if (pt === 'product') return true;
    } catch(e){}
    return /^\/products\//.test(location.pathname);
  }

  function findVisibleAtc() {
    var btns = document.querySelectorAll('button.gp-button-atc[name="add"], button[name="add"]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.offsetParent !== null && b.getBoundingClientRect().width > 0) return b;
    }
    return null;
  }

  function mountExpressCheckoutContainer() {
    if (document.querySelector('[data-sellabroad-express-checkout]')) {
      /* Already mounted — keep variant-id fresh and ask widget to re-render */
      var existing = document.querySelector('[data-sellabroad-express-checkout]');
      var vid = getSelectedVariantId();
      if (vid && existing.getAttribute('data-variant-id') !== vid) existing.setAttribute('data-variant-id', vid);
      return true;
    }
    var atc = findVisibleAtc();
    if (!atc || !atc.parentNode) return false;
    var variantId = getSelectedVariantId();
    var c = document.createElement('div');
    c.setAttribute('data-sellabroad-express-checkout', '');
    c.setAttribute('data-merchant-id', MERCHANT_ID);
    if (variantId) c.setAttribute('data-variant-id', variantId);
    c.setAttribute('data-show-apple-pay', 'true');
    c.setAttribute('data-show-google-pay', 'true');
    c.setAttribute('data-mode', 'production');
    c.className = 'sellabroad-express-checkout-widget';
    c.style.cssText = 'margin: 14px 0;';
    atc.parentNode.insertBefore(c, atc);
    return true;
  }

  function loadExpressCheckoutWidget() {
    /* Stamp merchant id on any mounted containers in case markup was edited */
    document.querySelectorAll('[data-sellabroad-express-checkout]').forEach(function(w){
      if (!w.getAttribute('data-merchant-id')) w.setAttribute('data-merchant-id', MERCHANT_ID);
    });
    if (document.querySelector('script[data-sellabroad-widget]')) {
      if (window.SellabroadExpressCheckout && window.SellabroadExpressCheckout.reinitialize) {
        window.SellabroadExpressCheckout.reinitialize();
      }
      return;
    }
    var script = document.createElement('script');
    script.async = true;
    script.setAttribute('data-sellabroad-widget', 'true');
    script.setAttribute('data-merchant-id', MERCHANT_ID);
    fetch('https://app.sellabroad.com/api/widget', { headers: { 'ngrok-skip-browser-warning': '69420' } })
      .then(function(r){ return r.text(); })
      .then(function(code){
        script.textContent = code;
        document.head.appendChild(script);
      })
      .catch(function(){});
  }

  function startExpressCheckout() {
    if (!isPdp()) return;
    /* Poll for the ATC button — GemPages can hydrate the product UI a couple
       of seconds after page load. Once mounted, kick the widget. */
    var attempts = 0;
    var iv = setInterval(function(){
      attempts++;
      if (mountExpressCheckoutContainer()) {
        loadExpressCheckoutWidget();
        clearInterval(iv);
      }
      if (attempts > 60) clearInterval(iv);
    }, 300);

    /* Variant change → update data-variant-id and ask widget to re-render */
    if (!window.__saExpressVariantWired) {
      window.__saExpressVariantWired = true;
      document.addEventListener('change', function(e){
        if (!e.target || !e.target.matches) return;
        if (!e.target.matches('input[name="id"], select[name="id"], .variant__input, input[name="options"], select[name="options"]')) return;
        var vid = getSelectedVariantId();
        if (!vid) return;
        document.querySelectorAll('[data-sellabroad-express-checkout]').forEach(function(w){
          w.setAttribute('data-variant-id', vid);
        });
        if (window.SellabroadExpressCheckout && window.SellabroadExpressCheckout.reinitialize) {
          window.SellabroadExpressCheckout.reinitialize();
        }
      });
    }
  }

  /* ---------- Footer payment icons ---------- */
  function ensurePaymentStyles() {
    if (document.getElementById('sa-payment-icons-style')) return;
    var s = document.createElement('style');
    s.id = 'sa-payment-icons-style';
    s.textContent = '.sa-footer-payment-icons{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;gap:12px;padding:16px 20px;margin:0 auto;list-style:none}.sa-footer-payment-icons img{width:42px;height:26px;object-fit:contain;display:block}body:not(.sa-geo-allowed) .sa-footer-payment-icons{display:none !important}';
    document.head.appendChild(s);
  }
  function updateFooterPayments(country) {
    ensurePaymentStyles();
    var key = String(country || '').toUpperCase();
    var names = COUNTRY_FOOTER_ICONS[key] || DEFAULT_FOOTER_ICONS;
    var iconMap = {};
    PAYMENT_ICON_LIST.forEach(function(i){ iconMap[i.name] = i; });
    var icons = names.map(function(n){ return iconMap[n]; }).filter(Boolean);
    var sig = icons.map(function(i){ return i.name; }).join('|');
    var container = document.querySelector('.sa-footer-payment-icons');
    if (!container) {
      var footer = document.querySelector('footer') || document.querySelector('.shopify-section-group-footer-group');
      if (!footer) return;
      container = document.createElement('ul');
      container.className = 'sa-footer-payment-icons';
      footer.appendChild(container);
    }
    if (container.dataset.saSig === sig) return;
    container.dataset.saSig = sig;
    container.innerHTML = '';
    icons.forEach(function(icon){
      var li = document.createElement('li');
      var img = document.createElement('img');
      img.src = icon.src; img.alt = icon.name; img.title = icon.name;
      img.loading = 'lazy'; img.width = 42; img.height = 26;
      li.appendChild(img);
      container.appendChild(li);
    });
  }

  /* Reset loading state + cart-mirror cache on every page restore.
     Handles bfcache (back button from sa-chk → cart still showed disabled button) and any redirect-failure case where we navigated then came back. */
  window.addEventListener('pageshow', function(e){
    try {
      document.querySelectorAll('.sa-loading').forEach(function(el){ el.classList.remove('sa-loading'); });
    } catch(err){}
    mirrorPromise = null;
    cartId = null;
    window.__saNavigating = false;
    if (e.persisted) {
      var c = window.__saGeoCountry || readCachedCountry();
      if (c) { applyBodyState(c); if (isGeoAllowed(c)) { convertAllPrices(COUNTRY_TO_CCY[c]); updateFooterPayments(c); installUpCartShadow(); } }
    }
  });

  /* ---------- Boot ---------- */
  function bootIfAllowed() {
    if (window.__saGeoCountry && isGeoAllowed(window.__saGeoCountry)) {
      applyBodyState(window.__saGeoCountry);
      convertAllPrices(COUNTRY_TO_CCY[window.__saGeoCountry]);
      updateFooterPayments(window.__saGeoCountry);
      installUpCartShadow();
      startExpressCheckout();
    }
  }
  /* Start UpCart shadow polling IMMEDIATELY too — guarantees SA's capture
     listener is registered inside the shadow root before Peptide-Pay's
     bubble-phase listener (which starts polling at end-of-body parse). */
  installUpCartShadow();

  if (document.readyState !== 'loading' && document.body) bootIfAllowed();
  else document.addEventListener('DOMContentLoaded', bootIfAllowed, { once:true });

  /* Background refresh — handles VPN flips and first-visit cases */
  fetchGeo();
})();
